import React, { useState, useRef, useContext } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/packages/blue-book-player/library/button-with-icon';
import Popover from 'chameleon/packages/blue-book-player/library/popover';
import useCurrentQuestionLoad from 'chameleon/packages/blue-book-player/hooks/useCurrentQuestionLoad';
import { BluebookContext } from '../../state/BluebookContext';
import NavigatorContent from './NavigatorContent';
import { SET_IS_REVIEW_PAGE } from '../../state/reducer';

const QuestionNavigator = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showNavigator, setShowNavigator] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const popoverRef = useRef(null);
  const openPopoverButtonRef = useRef(null);
  const { state: playerState, dispatch } = useContext(BluebookContext);
  const { title, isReviewPage } = playerState;

  const { learnosityApp } = props;

  const updateItemIndex = (newItemIndex) => {
    setCurrentIndex(newItemIndex);
  };

  useCurrentQuestionLoad(learnosityApp, (itemIndex) => {
    const learnosityItems = learnosityApp?.getItems();
    const learnosityItemsArray = Object.keys(learnosityItems || {});

    setTotalQuestions(learnosityItemsArray.length);
    setCurrentIndex(itemIndex);
    setShowNavigator(true);

    learnosityApp.on('item:changed', updateItemIndex);

    return () => {
      learnosityApp.off('item:changed', updateItemIndex);
    };
  });

  const onClosePopover = (shouldFocusTrigger) => {
    setIsExpanded(false);
    if (shouldFocusTrigger) {
      // Adding this timeout because the reader still read the button expanded even if it is collapsed
      setTimeout(() => {
        openPopoverButtonRef?.current?.focus();
      }, 0);
    }
  };

  if (!showNavigator || isReviewPage) {
    return null;
  }

  const handleClose = (shouldClosePopover = true) => {
    popoverRef?.current?.close(shouldClosePopover);
  };

  const navigateToReviewPage = () => {
    dispatch({ type: SET_IS_REVIEW_PAGE, payload: true });
  };
  return (
    <div className="h-full bb-mobile:flex">
      <Popover
        position="top"
        ref={popoverRef}
        onOpen={() => setIsExpanded(true)}
        onClose={onClosePopover}
        arrowSize="xl"
        customBoxShadow="!shadow-[0_0_8px_rgba(0,0,0,0.25)]"
        initialFocus={currentIndex + 1}
        shouldFocusTrigger
        trigger={
          <ButtonWithIcon
            size="custom"
            isRounded={false}
            className="bg-bluebook-gray-900 border-[1px] border-white rounded-[7px] text-white"
            accessibility={{
              'aria-expanded': isExpanded,
              'aria-label': `Question Navigator Question ${currentIndex + 1} of ${totalQuestions}`,
            }}
            ref={openPopoverButtonRef}
            icon="question_navigator_arrow"
            iconWidth={16}
            iconHeight={16}
            iconClassName={cn({ 'rotate-180': isExpanded })}
            iconOrientation="right"
          >
            <div className="h-[32px] flex justify-between gap-2 items-center font-semibold text-[15px] ml-[10px] pr-[5px] ">
              <span className="bb-mobile:hidden">Question</span>
              <span>
                {currentIndex + 1} of {totalQuestions}
              </span>
            </div>
          </ButtonWithIcon>
        }
      >
        <NavigatorContent
          handleClose={handleClose}
          quizTitle={title}
          currentQuestionIndex={currentIndex}
          learnosityApp={learnosityApp}
          navigateToReviewPage={navigateToReviewPage}
        />
      </Popover>
    </div>
  );
};

QuestionNavigator.propTypes = {
  learnosityApp: PropTypes.object,
};

QuestionNavigator.defaultProps = {
  learnosityApp: null,
};

export default QuestionNavigator;
